<template>
  <div>
    <v-dialog
      v-model="main_dialog"
      :max-width="max_width"
      :persistent="persistent"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ form_title }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="crudForm" v-model="valid">
            <slot name="model_form" :is_new="is_new">No Inputs</slot>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close_edit"> Cancel </v-btn>
          <v-btn color="blue darken-1" text @click="persist" :disabled="!valid">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_delete" max-width="650px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this
          {{ model_name ? model_name : "Item" }}?</v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <slot name="model_view">No View</slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close_delete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="delete_confirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    model_name: {
      type: String,
      default: null,
    },
    form_title_overload: {
      type: String,
      default: null,
    },
    max_width: {
      type: String,
      default: "600px",
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      is_new: true,
      main_dialog: false,
      dialog_delete: false,
    };
  },
  methods: {
    open_edit(is_new) {
      this.is_new = is_new;
      this.reset_validation();
      this.main_dialog = true;
      // this.valid = false;
    },
    close_edit() {
      this.reset_validation();
      this.main_dialog = false;
    },
    persist() {
      this.$emit("persist", this.is_new);
    },
    open_delete() {
      this.dialog_delete = true;
    },
    close_delete() {
      this.dialog_delete = false;
      this.$emit("close");
    },
    delete_confirm() {
      this.$emit("erase");
    },
    reset_validation(val) {
      if (this.$refs.crudForm) {
        this.$refs.crudForm.validate();
        this.$refs.crudForm.resetValidation();
      }
    },
  },
  watch: {
    main_dialog(nval) {
      if (nval == false) {
        this.$emit("close");
      }
    },
  },
  computed: {
    form_title() {
      if (this.form_title_overload) return this.form_title_overload;
      return this.is_new ? `New ${this.model_name}` : `Edit ${this.model_name}`;
    },
  },
};
</script>
